import React from "react";
import Text from "@streeteasy/design-system/deprecated/Text";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { func, string } from "prop-types";

import { verificationSentGA } from "../../../../analytics/ga";
import {
  ConfirmationWrapper,
  MobileLineBrake,
  ModalHeading,
  ModalText,
  ModalTitle,
  TextBold,
  XButtonWrapper
} from "../../styled";

class VerificationSent extends React.Component {
  static defaultProps = {
    email: "",
    handleCloseModal: null,
    scenario: ""
  };

  static propTypes = {
    email: string,
    handleCloseModal: func,
    scenario: string
  };

  // GA starts
  componentDidMount() {
    if (localStorage.getItem("analytics")) {
      this.source = JSON.parse(localStorage.getItem("analytics")).source || "";
      verificationSentGA.welcomeBackModalOpen(this.source);
    }
  }
  // GA ends

  render() {
    const { email, handleCloseModal, scenario } = this.props;

    return (
      <ConfirmationWrapper minHeight>
        <ModalHeading scenario={scenario}>
          <ModalTitle scenario={scenario} type="primarySm">
            Welcome back!
          </ModalTitle>
          <XButtonWrapper>
            <XButton onClick={handleCloseModal} />
          </XButtonWrapper>
        </ModalHeading>
        <ModalText>
          <Text type="sm">
            <span>
              For access to your account, use the link in the email we sent to
            </span>
            <span>
              &nbsp;
              <wbr />
            </span>
            <MobileLineBrake>
              <TextBold as="span" type="sm">
                {email}
              </TextBold>
            </MobileLineBrake>
          </Text>
        </ModalText>
      </ConfirmationWrapper>
    );
  }
}

export default VerificationSent;
